import styled from "styled-components";

export const Container = styled.div`
  padding: 0;
  width: 100%;
  height: 100%;
  max-width: 9.9375rem;
  // Item de um flex (ContainerDolarAndQuotation, em pages/nova-farm/styles.js) -
  // sem isso, o min-width implícito do flexbox ("auto") impede encolher abaixo
  // do conteúdo interno, estourando o max-width acima e vazando do card.
  min-width: 0;
  max-height: 15.6875rem;
  
  margin: 0;
  display: flex;
  flex-direction: column;
  
  background: #fff;
  text-align: center;
  border-radius: 0.9375rem;
  background-color: #F8F8F9;

  h2 {
    display: flex;
    gap: 0.3125rem;
    align-items: center;
    justify-content: center;
    
    color: #589BFF;
    font-size: 0.5625rem;
    letter-spacing: 0.0625rem;
  }

  .rate-info {
    padding: 1rem;
    padding-bottom: 0;
    
    gap: 0.6rem;
    display: flex;
    align-items: center;
    flex-direction: column;

    span {
      font-size: 0.75rem;
      margin-top: 0.25rem;
    }

    .rate-details {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }
  }

  .custom-selector {
    position: relative;
    cursor: pointer;

    button {
      background: none;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-block: 0.5rem;

      img {
        width: 1rem;
        height: 1rem;
        padding-left: 0.1rem;
      }
    }

    ul {
      left: 50;
      top: 1.5rem;
      padding: 0.5rem;
      list-style: none;
      position: absolute;
      max-height: 150px;
      
      margin: 0;
      
      z-index: 10;
      background: #fff;
      border: 1px solid #ddd;
      border-radius: 0.25rem;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

      li {
        padding: 0.3rem;
        
        cursor: pointer;
        transition: background 0.2s;
        font-size: .7rem;

        &:hover {
          background: #f0f0f0;
        }

        &.selected {
          color: #589bff;
          font-weight: bold;
        }
      }
    }
  }

  .chart-wrapper {
    width: 100%;
    padding-bottom: 0.5rem;
    height: 6.875rem;
  }

  @media (max-width: 1310px) {
    max-width: 49%;
  }

  @media (max-width: 1080px) {
    max-width: 100%;
  }
`;
